<div *ngIf="listOnly; else select">
    <span *ngFor="let term of site.categories; trackBy: utils.trackByIndex">{{term.name}}</span>
</div>
<ng-template #select>
    <div class="dropdown terms" #dropdown [ngClass]="{faded: hasPrimaryCats()}">
        <button 
            class="trigger" 
            (click)="togglePanel()">
            <span *ngIf="site.categories.length > 0; else placeholder" class="selected" [title]="getText()" [innerHtml]="getText()"></span>
            <ng-template #placeholder>
                <span class="selected placeholder">—</span>
            </ng-template>
            <mat-icon>keyboard_arrow_down</mat-icon> 
        </button>
        <div class="options-panel mat-elevation-z2" [ngClass]="{'open': panelOpen}">
            <ul class="options">
                <ng-container *ngIf="options.length > 0; else none">
                    <li *ngFor="let option of options; let i = index; trackBy: utils.trackByIndex">
                        <mat-checkbox class="site-category-checkbox" [disabled]="canEdit !== true" [(ngModel)]="option.checked" (change)="changeOption(option)">{{option.name}}</mat-checkbox>
                        <button *ngIf="option.checked && site.categories[0].name != option.name && canEdit == true" class="site-category-make-primary" mat-button (click)="makePrimary(option)">Make Primary</button>
                        <button *ngIf="option.checked && site.categories[0].name == option.name" class="site-category-make-primary" mat-button disabled>Primary</button>
                    </li>
                </ng-container>
                <ng-template #none>
                    <li>No terms</li>
                </ng-template>
            </ul>
        </div>
    </div>
</ng-template>